import logo from "assets/img/logo/logo_aig_login-2.png";
import React from "react";
import LoadingScreen from "react-loading-screen";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { FetchListadoEndosos } from "../../redux/actions/aEndososBeneficiarios";
import TablaVehiculos from "./Vehiculos/TablaVehiculos";
import { ramos_coberturas, ramos_endosos_beneficiarios } from "../../utils/constants";
import SeleccionEndosos from "./SeleccionEndosos";
import TablaHogar from "./Hogar/TablaHogar";


class ListaEndosos extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  async componentDidMount() {
    const queryParams = new URLSearchParams(this.props.location.search);
    const poliza = queryParams.get("poliza");
    const sucursal = queryParams.get("sucursal");
    const ramo = queryParams.get("ramo");
    const body = {
      poliza,
      sucursal,
      ramo
    };
    this.setState(body);
  }

  ingresarEndoso = (endoso) => {
    this.setState({
      paso: "seleccionEndoso",
      endosoSeleccionado: endoso
    });
  }

  cancelarEndoso = () => {
    this.setState({
      paso: "listado",
    });
  }

  insertarCabeceraBeneficiarios = (cabecera) => {
    this.setState({
      cabecera: cabecera,
    });
  }

  renderTabla = () => {
    if (ramos_endosos_beneficiarios[this.state.ramo] !== undefined) {
      return (
        <>
          {ramos_endosos_beneficiarios[this.state.ramo] === "vehiculos" && (
            <TablaVehiculos
              {...this.state}
              funciones={
                {
                  insertarCabeceraBeneficiarios: this.insertarCabeceraBeneficiarios,
                  ingresarEndoso: this.ingresarEndoso
                }
              }
            />
          )}
          {ramos_endosos_beneficiarios[this.state.ramo] === "hogar" && (
            <TablaHogar
              {...this.state}
              funciones={
                {
                  insertarCabeceraBeneficiarios: this.insertarCabeceraBeneficiarios,
                  ingresarEndoso: this.ingresarEndoso
                }
              }
            />
          )}
        </>
      );
    }
  }

  render() {
    const {
      datosEndosos
    } = this.props;
    return (
      <LoadingScreen
        loading={datosEndosos.isLoadingEndosos}
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text={"Obteniendo registros..."}
      >
        {this.renderTabla()}
      </LoadingScreen>
    );
  }
}

const mapStateToProps = (state) => ({
  datosEndosos: state.dataEndosos ? state.dataEndosos : false
});

const mapDispatchToProps = (dispatch) => {
  return {

  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ListaEndosos)
);